export default "__VITE_ASSET__DuU2fS74__"